<template>
<!-- Will get  -->
<div>
  <div v-if="!reappraise && !isPostExam">
    <el-form-item label = "Απόφαση Προέδρου"
      v-if="fromProponent || fromAcademicDirector || fromBoard || fromConsultant || fromConsultantOverdue || fromAcademicDirector2"
      >
      <el-radio-group v-model="presidentJudgement.decision_type" @change="togglePresidentDecision">
        <el-radio label="Συμφωνία" border v-if="!fromConsultantOverdue"></el-radio>
        <el-radio label="Παραπομπή σε Αξιολογητή" border
          v-if="!fromAcademicDirector2 && !fromConsultant2"></el-radio>
        <el-radio
          v-if="fromBoard" label="Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα" border>
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="fromConsultantOverdue">
          <el-alert type="info" title="Πρόκειται για αίτηση που επιστρέφει μετά από την παρέλευση 15ήμερου χωρίς υποβολή εισήγησης αξιολογητή." show-icon></el-alert>
        </el-form-item>
    <el-form-item
      label="Επιλογή Απόφασης"
      v-if="this.presidentJudgement.decision_type === 'Συμφωνία' || fromVice">
      <el-select
        class="bigger"
        v-model="presidentJudgement.decision"
        filterable
        placeholder="Παρακαλώ Επιλέξτε"
        @change='toggleFinalDecision'
      >
        <el-option v-for="finalDecision in validatedFinalDecisions"
          :key="finalDecision.id"
          :label="finalDecision.decision_text"
          :value="finalDecision.id"
          filterable>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="showCorespWith"
      label = "Με">
      <el-select
        v-model="presidentJudgement.departmentName"
        filterable
        placeholder="Παρακαλώ Επιλέξτε"
        @change='toggleTitlesCorrespondence'
        class="bigger">
        <el-option
            :value="titlesCorrespondence.universityDepartment.name" :label="titlesCorrespondence.universityDepartment.name" :key="titlesCorrespondence.universityDepartment.id">
        </el-option>
        <!-- <el-option v-for="item in titlesCorrespondence.universityDepartment"
          :key="item.id"
          :label="item.name"
          :value="item.name"
          filterable>
        </el-option> -->
      </el-select>
    </el-form-item>
    <!-- <el-form-item v-if="showCorespWith">
    <el-alert :closable='false' v-if="showCorespWith" :title="'Ο αιτών επιθυμεί αντιστοίχιση με: ' + titlesCorrespondence.universityDepartment.name + ' ή ' + titlesCorrespondence.TEIDepartment.name" type="info" show-icon></el-alert>
    </el-form-item>
    <el-form-item
      v-if="showCorespWith"
      label = "Με">
      <el-autocomplete popper-class="my-autocomplete" v-model="presidentJudgement.departmentName" :fetch-suggestions="querySearchDepartment" placeholder="Επιλέξτε Τμήμα" @select="handleSelectDepartment">
        <template slot-scope="{ item }">
          <div class="value">{{ item.departmentInstitution }}</div><span class="link">{{ item.departmentName }} ({{item.departmentID}})</span>
        </template>
      </el-autocomplete>
    </el-form-item> -->
    <el-form-item label="Ανάθεση σε Αντιπρόεδρο"
      v-if="presidentJudgement.decision_type === 'Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα'">
      <el-select v-model="assignedToVicePresident" placeholder="Παρακαλώ Επιλέξτε">
        <el-option label="Αντιπρόεδρος Α" value="VicePresidentA"></el-option>
        <el-option label="Αντιπρόεδρος Β" value="VicePresidentB"></el-option>
      </el-select>
    </el-form-item>
  </div>
  <!-- <div v-else> -->
  <div v-if="reappraise">
    <el-form-item label = "Απόφαση Προέδρου">
      <el-radio-group v-model="presidentJudgement.reappraisalDecisionType" @change="changeReappDecisionType">
        <el-radio label="Πλήρης Ικανοποίηση" border></el-radio>
        <el-radio v-if="reappDegreeType === 'bachelor' && !fromBoard" label="Μερική Ικανοποίηση" border></el-radio>
        <el-radio v-if="fromAcademicDirectorReappraisal || this.isSecondReappraisal" label="Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης" border></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label = "Επιλογή Απόφασης" v-if="![null, 'Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης'].includes(this.presidentJudgement.reappraisalDecisionType)">
    <!-- <el-form-item label = "Επιλογή Απόφασης" v-if="![null, 'Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης'].includes(reappDecisionType)"> -->
      <!-- <el-select v-model="presidentJudgement.decision" filterable placeholder="Παρακαλώ Επιλέξτε"> -->
      <el-select v-model="presidentJudgement.decision" filterable placeholder="Παρακαλώ Επιλέξτε"
        @change="changeReappDecision" style="width: 700px;">
        <el-option v-for="reappDecision in validatedReappDecisions"
          :key="reappDecision.id"
          :label="reappDecision.decision_text"
          :value="reappDecision.id"
          filterable>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="showCorespWith"
      label = "Με">
      <el-select
        v-model="presidentJudgement.departmentName"
        filterable
        placeholder="Παρακαλώ Επιλέξτε"
        @change='toggleTitlesCorrespondence'
        class="bigger">
        <el-option v-for="item in titlesCorrespondence"
          :key="item.id"
          :label="item.name"
          :value="item.name"
          filterable>
        </el-option>
      </el-select>
    </el-form-item>

    <!-- <el-form-item v-if="showCorespWith">
      <el-alert :closable='false' v-if="showCorespWith" :title="'Ο αιτών επιθυμεί αντιστοίχιση με: ' + titlesCorrespondence.universityDepartment.name + ' ή ' + titlesCorrespondence.TEIDepartment.name" type="info" show-icon></el-alert>
    </el-form-item>
    <el-form-item
      v-if="showCorespWith"
      label = "Με">
      <el-autocomplete popper-class="my-autocomplete" v-model="presidentJudgement.departmentName" :fetch-suggestions="querySearchDepartment" placeholder="Επιλέξτε Τμήμα" @select="handleSelectDepartment">
        <template slot-scope="{ item }">
          <div class="value">{{ item.departmentInstitution }}</div><span class="link">{{ item.departmentName }} ({{item.departmentID}})</span>
        </template>
      </el-autocomplete>
    </el-form-item> -->
  </div>
  <div v-if="isPostExam">
    <el-form-item label = "Απόφαση Προέδρου">
      <el-radio-group v-model="presidentJudgement.decision_type">
        <el-radio label="Συμφωνία" border></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="Επιλογή Απόφασης"
      v-if="this.presidentJudgement.decision_type === 'Συμφωνία'">
      <el-select
        class="bigger"
        v-model="presidentJudgement.decision"
        filterable
        placeholder="Παρακαλώ Επιλέξτε"
        @change='toggleFinalDecision'
      >
        <el-option v-for="finalDecision in validatedFinalDecisions"
          :key="finalDecision.id"
          :label="finalDecision.decision_text"
          :value="finalDecision.id"
          filterable>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="showCorespWith"
      label = "Με">
      <el-select
        v-model="presidentJudgement.departmentName"
        filterable
        placeholder="Παρακαλώ Επιλέξτε"
        @change='toggleTitlesCorrespondence'
        class="bigger">
        <el-option
            :value="titlesCorrespondence.universityDepartment.name" :label="titlesCorrespondence.universityDepartment.name" :key="titlesCorrespondence.universityDepartment.id">
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import config from '../../config.js'
export default {
  props: ['validatedFinalDecisions', 'presidentJudgement',
    'titlesCorrespondence', 'fromBoard', 'fromConsultant',
    'fromConsultant2', 'fromConsultantOverdue',
    'fromProponent', 'fromAcademicDirector', 'fromVice', 'fromAcademicDirector2', 'fromViceThroughBoard',
    'fromViceThroughReappraisalBoard', 'reappraise', 'isPostExam', 'isSecondReappraisal',
    'fromAcademicDirectorReappraisal', 'reappDegreeType'],
  mounted: function () {
    if (!this.isPostExam) {
      this.getRoleMembers(4)
      this.getDepts()
    }
  },
  data () {
    return {
      validatedReappDecisions: [],
      correspondenceDepartment: ''
      // usersToAssign: []
    }
  },
  methods: {
    getAvailableReappDecisions (decisionType, degreeType) {
      this.validatedReappDecisions = []
      switch (decisionType) {
        case 'Πλήρης Ικανοποίηση':
          switch (degreeType) {
            case 'bachelor':
              this.validatedReappDecisions = this.validatedFinalDecisions.filter(decision => [18, 19, 22].includes(decision.id))
              break
            case 'master':
              this.validatedReappDecisions = this.validatedFinalDecisions.filter(decision => [20].includes(decision.id))
              break
            case 'phd':
              this.validatedReappDecisions = this.validatedFinalDecisions.filter(decision => [21].includes(decision.id))
              break
          }
          break
        case 'Μερική Ικανοποίηση':
          if (degreeType === 'bachelor') {
            this.validatedReappDecisions = this.validatedFinalDecisions.filter(decision => [22].includes(decision.id))
          }
          break
        case 'Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης':
      }
    },
    getRoleMembers (roleId) {
      this.usersToAssign = []
      // this.loadingRoleMembers = true
      axios.get(
        `${config.BASE_URL}/roles/${roleId}`
      ).then((response) => {
        this.usersToAssign = response.data.data
        if (this.presidentJudgement.decision_type) {
          this.togglePresidentDecision(this.presidentJudgement.decision_type)
        }
        console.log('this.usersToAssign', this.usersToAssign)
        // this.usersToAssign = this.usersToAssign.sort(this.compare)
      }, (err) => {
        this.backendError(err)
        // this.loadingRoleMembers = false
      })
    },
    getDepts () {
      axios
        .get(
          `${config.BASE_URL}/deptsForCorrespondence`
        )
        .then(response => {
          this.allDepartments = response.data.data.aei.concat(response.data.data.tei)
        })
    },
    querySearchDepartment (queryString, cb) {
      var results =
        this.allDepartments && queryString !== null
          ? this.allDepartments.filter(this.createFilter(queryString))
          : this.allDepartments
      // call callback function to return suggestion objects
      cb(results)
    },
    createFilter (queryString) {
      return link => {
        return (
          link.departmentName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelectDepartment (item) {
      // this.correspondenceDepartment = `${item.departmentName} (${item.departmentID}) - ${item.departmentInstitution}`
      this.presidentJudgement.departmentName = `${item.departmentName} `
    },
    changeReappDecision () {
    },
    changeReappDecisionType (value) {
      this.presidentJudgement.decision = null
      this.getAvailableReappDecisions(this.presidentJudgement.reappraisalDecisionType, this.reappDegreeType)
    },
    togglePresidentDecision (val) {
      this.presidentJudgement.decision_type = val
      this.presidentJudgement.decision = null
      this.presidentJudgement.departmentName = null
      this.assignedToVicePresident = null
      this.$emit(
        'changedPresidentDecision',
        this.presidentJudgement.decision,
        this.presidentJudgement.decision_type,
        this.usersToAssign,
        this.presidentJudgement.departmentName,
        this.assignedToVicePresident)
    },
    // toggleReappraisalType (val) {
    //   this.presidentJudgement.reappraisalDecisionType = val
    //   this.presidentJudgement.decision = null
    //   this.presidentJudgement.departmentName = null
    //   this.$emit(
    //     'changedPresidentReappraisalDecision',
    //     this.presidentJudgement.decision,
    //     this.presidentJudgement.reappraisalDecisionType,
    //     this.presidentJudgement.departmentName,
    //     this.assignedToVicePresident)
    // },
    toggleFinalDecision (val) {
      this.presidentJudgement.decision = val
      this.presidentJudgement.departmentName = null
      this.assignedToVicePresident = null
      console.log('toggleFinalDecision', this.presidentJudgement.decision, this.presidentJudgement.decision_type, this.presidentJudgement.departmentName)
      this.$emit(
        'changedPresidentDecision',
        this.presidentJudgement.decision,
        this.presidentJudgement.decision_type,
        this.presidentJudgement.departmentName)
    },
    toggleTitlesCorrespondence (val) {
      this.presidentJudgement.departmentName = val
    }
  },
  computed: {
    // decision () {
    //   this.setDecision(this.presidentJudgement.decision)
    //   return this.presidentJudgement.decision
    // },
    showCorespWith () {
      if (!this.reappraise) {
        console.log('this.presidentJudgement.decision_type', this.presidentJudgement.decision_type)
        console.log('this.presidentJudgement.decision', this.presidentJudgement.decision)
        return (this.presidentJudgement.decision_type === 'Συμφωνία') &&
        [1, 3, 12, 13, 17].includes(this.presidentJudgement.decision)
      } else if (this.reappraise) {
        return ([7, 9].includes(this.presidentJudgement.decision))
      }
    },
    assignedToVicePresident: {
      get: function (val) {
        if (['VicePresidentA', 'VicePresidentB'].includes(this.presidentJudgement.assignedTo.role)) {
          return this.presidentJudgement.assignedTo.role
        } else {
          return null
        }
      },
      set: function (value) {
        this.presidentJudgement.assignedTo.role = value
      }
    }
  },
  watch: {
  }
}

</script>

<style lang="scss" scoped>
.big {
  &.el-select {
    width: 450px;
  }
}
.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
.bigger {
  &.el-select {
    width: 620px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PresidentDecision.vue